import { EyedropperVariantIcon } from './EyedropperVariantIcon';

/**
 * author: Google
 * id 24A1E7A8-D8A4-4216-B467-72C144972358
 * name eyedropper-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eyedropper-variant.svg
 * tags
 * - Color 
 * - Science 
 */
export const ColouriseIcon = EyedropperVariantIcon;
export default ColouriseIcon